import LanguageDetector from 'i18next-browser-languagedetector';
import ptBr from './pt-br';
import enUs from './en-us';
import esEs from './es-es';
import i18next from 'i18next';

export default async function initI18n(i18n: typeof i18next) {
  await i18n.use(LanguageDetector).init({
    resources: {
      'pt-BR': ptBr,
      'en-US': enUs,
      'es-ES': esEs,
    },
    fallbackLng: 'pt-BR',
  });
}
